export default "__VITE_ASSET__DUQf5BKS__"